import * as React from 'react';
import { st, classes } from './Badge.base.st.css';
export class BadgeBase extends React.Component {
    static { this.displayName = 'BadgeBase'; }
    render() {
        const { className, children, icon, ...rest } = this.props;
        return (React.createElement("div", { className: st(classes.root, { withIcon: !!icon }, className), ...rest },
            React.createElement("div", { className: classes.innerContainer },
                icon && (React.createElement("div", { "data-hook": "badge-icon", className: classes.icon }, icon)),
                children)));
    }
}
//# sourceMappingURL=Badge.base.js.map